const contentByQuestion = {
  hasEaten: {
    title: 'Are you hungry right now?',
    leftButtonText: 'No, I’m not.',
    rightButtonText: 'Yeah, I am.',
    eventName: 'Check-in: Are you hungry right now?',
  },
  hasSlept: {
    title: 'Did you sleep well last night?',
    leftButtonText: 'Yes I did.',
    rightButtonText: 'No, I didn’t.',
    eventName: 'Check-in: Did you sleep last night?',
  },
  hurtOrSick: {
    title: 'Are you hurt or sick?',
    leftButtonText: 'Yes, I am.',
    rightButtonText: 'No, I’m not.',
    eventName: 'Check-in: Are you hurt or sick?',
  },
  okAtHome: {
    title: 'Do you want to talk about something that’s going on at home?',
    leftButtonText: 'No, thanks.',
    rightButtonText: 'Yeah.',
    eventName: 'Check-in: Do you want to talk about something that’s going on at home?',
  },
  bulliedAtSchool: {
    title: 'Is someone at school bothering you?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Is someone at school bothering you?',
  },
  feelingStressed: {
    title: 'Are you feeling stressed?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Are you feeling stressed?',
  },
  feelingLonely: {
    title: 'Are you feeling lonely?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Are you feeling lonely?',
  },
  overwhelmedByWorkload: {
    title: 'Is your workload at school overwhelming you?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Is your workload at school overwhelming you?',
  },
  okInSocialLife: {
    title: 'Is everything okay in your social life?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Is everything okay in your social life?',
  },
  feelingTired: {
    title: 'Are you feeling tired?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Are you feeling tired?',
  },
  feelingWorthless: {
    title: 'Are you feeling like you are worth less than others?',
    leftButtonText: 'Yes.',
    rightButtonText: 'No.',
    eventName: 'Check-in: Are you feeling like you are worth less than others?',
  },
} as const

export default contentByQuestion
